export default __webpack_public_path__ + "/assets/abc-home-Lifestyle_01.jpg";